import CreditorGrid from "@/features/creditor/CreditorGrid";

export default function Creditor() {

  return (
    <CreditorGrid/>
  )
}
